module.exports = __webpack_public_path__ + "img/en02.de085d2e.png";